/***************************************************************************
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

import React from 'react'

interface SimpleHotSpotProps {
  color?: string
}

const HotSpot: React.FC<SimpleHotSpotProps> = (props) => {
  return (
    <svg className="hot-spot">
      <ellipse
        cx="10"
        cy="10"
        rx="8"
        ry="8"
        fill={props.color || 'rgb(38, 38, 38)'}
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  )
}

export default HotSpot
